const Ordine = () => import("./Ordine")
const OrdineV2 = () => import("./OrdineV2")
const OrdineVendita = () => import("./OrdineVendita")
const OdvClienti = () => import("./OdvClienti")
const OdvCliente = () => import("./OdvCliente")
const NuovoOrdine = () => import("./NuovoOrdine")
const Proposte = () => import("./Proposte")
const ProposteV2 = () => import("./ProposteV2")
const ProposalDrawingWindow = () => import("./proposte-v2/ProposalDrawingWindow")
const Offerte = () => import("./Offerte")
import store from "../../store"
import { canAccessOrderV2 } from "./orderV2Access.mjs"

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    next('/login')
}

const ifOrderV2Allowed = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        next('/login')
        return
    }

    if (canAccessOrderV2(store.state.user.userdata)) {
        next()
        return
    }

    next({ name: 'Ordine', params: { codice: to.params.codice }, query: to.query })
}

export default [
    {
        path: '/ordini/cliente/:codice/:indirizzo?',
        name: 'ordini-cliente',
        meta: {menu: 'ordini', title: 'Ordini Cliente'},
        component: OdvCliente,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/clienti/aperti/',
        name: 'ordini-clienti-aperti',
        meta: {menu: 'ordini', title: 'Ordini Clienti Aperti'},
        component: OdvClienti,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/clienti/',
        name: 'ordini-clienti',
        meta: {menu: 'ordini', title: 'Nuovo Ordine Cliente'},
        component: NuovoOrdine,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordine/:codice',
        name: 'Ordine',
        meta: {menu: 'ordine', title: 'Ordine'},
        component: Ordine,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordine-v2/:codice',
        name: 'OrdineV2',
        meta: {menu: 'ordine', title: 'Ordine V2'},
        component: OrdineV2,
        beforeEnter: ifOrderV2Allowed,

    },
    {
        path: '/ordinev/:codice',
        name: 'OrdineVendita',
        meta: {menu: 'ordinev', title: 'Ordine Vendita'},
        component: OrdineVendita,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/proposte/',
        name: 'ordini-proposte',
        meta: {menu: 'ordini', title: 'Proposte'},
        component: Proposte,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/proposte-v2/disegno/',
        name: 'ordini-proposte-v2-drawing',
        meta: {title: 'Disegno proposta V2', fullscreen: true},
        component: ProposalDrawingWindow,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/proposte-v2/',
        name: 'ordini-proposte-v2',
        meta: {menu: 'ordini', title: 'Cicli da disegno V2'},
        component: ProposteV2,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/ordini/offerte/',
        name: 'ordini-offerte',
        meta: {menu: 'ordini', title: 'Offerte'},
        component: Offerte,
        beforeEnter: ifAuthenticated,

    },
]
